export const NFT_OF_THE_WEEK_MOCK = {
  asset: {
    name: 'Cheng Hoon Teng Temple',
    token_id: '405',
    id: 84,
    description: 'Cheng Hoon Teng Temple',
    country_code: 'MY',
  },
  type: 'WEEK',
  valid_from: 1767567600,
  valid_until: 1768172400,
};
